export const CART_ADD_ITEM = 'CART_ADD_ITEM';
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM';
export const CART_SAVE_ITEMS = 'CART_SAVE_ITEMS';
export const CART_FAIL = 'CART_FAIL';
// cartConstants.js

export const CART_SAVE_SHIPPING_ADDRESS = 'CART_SAVE_SHIPPING_ADDRESS';
export const CART_UPDATE_ITEMS = 'CART_UPDATE_ITEMS';
export const CART_SAVE_PAYMENT_METHOD = 'CART_SAVE_PAYMENT_METHOD';
export const CART_INCREMENT_QTY = 'CART_INCREMENT_QTY';
export const CART_DECREMENT_QTY = 'CART_DECREMENT_QTY';
export const CART_CLEAR_ITEMS = 'CART_CLEAR_ITEMS'; 
export const CART_SET_USER_ID = 'CART_SET_USER_ID'; 
